// 新公告
<template>
  <div>
    <p style="text-align: center">
      <span class="systemFont0"
        >{{ groupName }} {{ $t("p0403.newAnnouncement") }}</span
      >
    </p>
    <div class="main">
      <!-- 主题 -->
      <div style="text-align: left; margin-bottom:2px;">
        {{ $t("p0403.emailTitle") }}
      </div>
      <el-form :model="announcement" style="margin-bottom: 1%;">
        <el-form-item>
          <el-input
            size="noticeInput"
            v-model="announcement.emailTitle"
          ></el-input>
        </el-form-item>
      </el-form>
      <div v-if="!noticeAllFlag" style="text-align: left; margin-bottom: 1%">
        <!-- 添加公告模板  -->
        <el-button type="p0332Button" @click="getNoticeTemplateList">{{
          $t("p0403.announcementTemplate")
        }}</el-button>
      </div>
      <el-form v-if="!noticeAllFlag" :model="newAnnouncementForm">
        <el-input
          type="textarea"
          style="margin-bottom:8px;"
          size="noticeContentInput"
          :rows="7"
          v-model="newAnnouncementForm.desc"
        ></el-input>
        <!-- 选择 -->
        <el-form-item
          v-if="
            courseNameView ||
              dateAndTimeView ||
              companyView ||
              addressView ||
              studyReportLinkView ||
              courseCodeView ||
              courseEnrollCodeView ||
              videoCodeView ||
              videoCodePromoteView
          "
          style="text-align: left"
          :label="$t('p0403.select')"
        >
          <span v-if="courseNameView"
            >【<el-button size="text" @click="courseNameDialog">{{
              $t("p0403.courseName")
            }}</el-button
            >】</span
          >
          <span v-if="dateAndTimeView"
            >【<el-button @click="courseDateDialog" size="text">{{
              $t("p0403.dateAndTime")
            }}</el-button
            >】</span
          >
          <span v-if="companyView"
            >【<el-button @click="companyDialog" size="text">{{
              $t("p0403.company")
            }}</el-button
            >】</span
          >
          <span v-if="addressView"
            >【<el-button @click="addressDialog" size="text">{{
              $t("p0403.address")
            }}</el-button
            >】</span
          >
          <span v-if="studyReportLinkView"
            >【<el-button @click="studyReportLinkDialog" size="text">{{
              $t("p0403.studyReportLink")
            }}</el-button
            >】</span
          >
          <span v-if="courseCodeView"
            >【<el-button @click="courseCodeDialog" size="text">{{
              $t("p0403.courseCode")
            }}</el-button
            >】</span
          >
          <span v-if="courseEnrollCodeView"
            >【<el-button @click="courseEnrollCodesDialog" size="text">{{
              $t("p0403.courseEnrollCode")
            }}</el-button
            >】</span
          >
          <span v-if="videoCodeView"
            >【<el-button @click="videoCodeDialog" size="text">{{
              $t("p0403.videoCode")
            }}</el-button
            >】</span
          >
          <span v-if="videoCodePromoteView"
            >【<el-button @click="videoCodePromoteDialog" size="text">{{
              $t("p0403.videoCodePromote")
            }}</el-button
            >】</span
          >
        </el-form-item>
        <!-- 优惠码复选 -->
        <el-form-item class="couponType">
          <!-- <el-form-item> -->
          <el-checkbox-group v-model="checkList" @change="setMealSelect">
            <el-checkbox label="0" name="0" style="display: block;">{{
              this.newAnnouncementForm.couponCodeZh
            }}</el-checkbox>
            <el-checkbox label="1" name="1" style="display: block;">{{
              this.newAnnouncementForm.couponCodeEn
            }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div style="text-align: left;margin-top:10px;margin-bottom:15px;">
        {{ $t("p0403.body") }}
        <el-select
          @change="selectBodyTemplate(templateValue)"
          size="small"
          style="margin-left:10px;"
          v-model="templateValue"
          placeholder="请选择模板"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <!-- 自由模板 -->
      <div v-if="templateValue === '0'">
        <!-- 富文本框 -->
        <div>
          <editor
            :emailGroupId="emailGroupId"
            v-model="newAnnouncementForm.yourContent"
            style="width: 100%"
          ></editor>
        </div>
        <!-- 添加附件 -->
        <div style="height: 80px">
          <div style="text-align: left; margin-top: 1%">
            {{ $t("p0403.attachment") }}
          </div>
          <div style="border: 1px dashed #d7d7d7;">
            <uploadFile
              style="margin-left: 47%;"
              ref="uploadCardFile_1"
              :uploadButtonStyle="3"
              :uploadFile="{
                locationCode: locationCode,
                uploadBtnDisplayFlag: uploadBtnDisplayFlag
              }"
            >
            </uploadFile>
          </div>
        </div>
        <el-row class="foot-container">
          <!-- 预览 -->
          <el-button
            style="margin-bottom: 30px"
            type="submit"
            @click="preview"
            >{{ $t("p0403.preview") }}</el-button
          >
          <!-- 发送 -->
          <el-button
            style="margin-bottom: 30px"
            type="submit"
            @click="sendNotice"
            >{{ $t("p0403.send") }}</el-button
          >

          <!-- 返回 -->
          <el-button type="return" @click="$router.go(-1)">{{
            $t("common.back")
          }}</el-button>
        </el-row>
      </div>

      <!-- 自定义模板1 -->
      <div v-if="templateValue === '1'">
        <el-form :model="template1Form" style="margin-bottom: 1%;">
          <!-- 主题 -->
          <el-form-item>
            <el-input
              size="noticeInput"
              v-model="template1Form.topic"
            ></el-input>
          </el-form-item>

          <!-- 长图 -->
          <div
            style="height:208px;margin-bottom: 1%;margin-top: 1%;border: 1px solid #c0ccda;"
          >
            <uploadImg
              :uploadImgStyle="0"
              @getImgInfo="getImgInfo"
              :imgIndex="-1"
              @deleteFile="deleteFile"
            />
          </div>
          <!-- 富文本框 -->
          <div>
            <editor
              :emailGroupId="emailGroupId"
              v-model="template1Form.editorA"
              style="width: 100%"
            ></editor>
          </div>
          <!-- 可添加删除模板 -->
          <div
            style="display:flex;margin-top:1%;"
            v-for="(item, index) in imgTemplateForm"
            :key="index"
          >
            <div style="width:400px;height:208px;border: 1px solid #c0ccda;">
              <uploadImg
                :ref="'imgRef' + index"
                :uploadImgStyle="1"
                @getImgInfo="getImgInfo"
                :imgIndex="index"
                @deleteFile="deleteFile"
              />
            </div>
            <div style="width:100%; position: relative;">
              <el-form-item style="margin-left:1%">
                <el-input size="noticeInput" v-model="item.inputTitle">
                  <el-button
                    style="padding-right:10px;padding-left:10px;color:#333333;"
                    slot="append"
                    type="text"
                    @click="addLink(index, item.inputTitle)"
                    >{{
                      item.inputTitleLink
                        ? $t("p0403.updateLink")
                        : $t("p0403.addLink")
                    }}</el-button
                  ></el-input
                >
              </el-form-item>

              <el-button
                style="position: absolute; top: 0; right: -90px;"
                type="danger"
                plain
                v-show="imgTemplateForm.length > 1"
                @click="deleteImgTemplateItem(index)"
                >{{ $t("common.delete") }}</el-button
              >
              <el-form-item style="margin-left:1%;margin-top:13px;">
                <el-input
                  type="textarea"
                  size="noticeContentInput"
                  :rows="6"
                  v-model="item.inputContent"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <!-- 添加按钮 -->
          <div style="text-align: left; margin-top:1%;">
            <el-button @click="addimgTemplateForm">
              <i class="el-icon-plus"></i>
              {{ $t("common.add") }}
            </el-button>
          </div>
          <!-- 富文本框 -->
          <div style="margin-top:1%;">
            <editor
              :emailGroupId="emailGroupId"
              v-model="template1Form.editorB"
              style="width: 100%"
            ></editor>
          </div>
        </el-form>
        <el-row class="foot-container">
          <!-- 预览 -->
          <el-button
            style="margin-bottom: 30px"
            type="submit"
            @click="preview1"
            >{{ $t("p0403.preview") }}</el-button
          >
          <!-- 发送 -->
          <el-button
            style="margin-bottom: 30px"
            type="submit"
            @click="sendNotice1"
            >{{ $t("p0403.send") }}</el-button
          >

          <!-- 返回 -->
          <el-button type="return" @click="$router.go(-1)">{{
            $t("common.back")
          }}</el-button>
        </el-row>
      </div>
    </div>
    <!-- 选择模板下拉框 -->
    <el-dialog
      :close-on-click-modal="false"
      width="40%"
      @close="returnBack(1)"
      :title="$t('p0403.selectAnnouncementTemplate')"
      :visible.sync="templateFormVisible"
    >
      <el-form :model="templateForm">
        <!-- 选择模板 -->
        <el-form-item
          label-width="70px"
          :label="$t('p0403.selectTemplate')"
          prop="courseNumber"
        >
          <el-select
            autosize
            size="small"
            style="width: 60%"
            v-model="templateForm.templateLabel"
            @change="getNoticeTemplateContent"
            :placeholder="$t('common.pleaseSelect')"
          >
            <el-option
              v-for="item in noticeTemplateList"
              :key="item.templateId"
              :label="item.title"
              :value="item.templateId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-input
          disabled
          style="margin-top: 3%"
          type="textarea"
          :rows="5"
          v-model="templateForm.textarea"
        >
        </el-input>
      </el-form>
      <div class="foot-container">
        <el-button type="submit" @click="searchString">{{
          $t("common.add")
        }}</el-button>
        <el-button type="return" @click="returnBack(1)">{{
          $t("common.back")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 课程名称选框 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('p0403.selectCourseName')"
      width="600px"
      :visible.sync="courseNameDialogFormVisible"
      @close="returnBack(2)"
    >
      <el-form
        :model="newAnnouncementForm"
        ref="newAnnouncementForm1"
        :hide-required-asterisk="true"
      >
        <!-- 课程名称 -->
        <el-form-item
          :label-width="labelWidth"
          :label="$t('p0403.selectCourseName')"
          prop="courseName"
        >
          <el-select
            v-model="newAnnouncementForm.courseName"
            size="small"
            filterable
            clearable
            style="width: 80%"
            :placeholder="$t('common.pleaseSelect')"
          >
            <el-option
              v-for="item in courseNameList"
              :key="item.courseNumber"
              :label="item.courseName"
              :value="item.courseName"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="foot-container">
        <el-button type="submit" @click="replaceCourseName">{{
          $t("common.confirm")
        }}</el-button>
        <el-button type="return" @click="returnBack(2)">{{
          $t("common.back")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 学习报告链接选框 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('p0403.studyReportLink')"
      width="600px"
      :visible.sync="studyReportLinkDialogFormVisible"
      @close="returnBack(6)"
    >
      <el-form
        :model="newAnnouncementForm"
        ref="newAnnouncementForm6"
        :hide-required-asterisk="true"
      >
        <!-- 学习报告课程名称 -->
        <el-form-item
          :label-width="labelWidth"
          :label="$t('p0403.studyReportCourseNumber')"
          prop="studyReportCourseNumber"
        >
          <el-select
            v-model="newAnnouncementForm.studyReportCourseNumber"
            size="small"
            filterable
            clearable
            @change="replaceStudyReportLink"
            style="width: 80%"
            :placeholder="$t('common.pleaseSelect')"
          >
            <el-option
              v-for="item in courseNameList"
              :key="item.courseNumber"
              :label="item.courseName"
              :value="item.courseName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 学习报告排课日期时间 -->
        <el-form-item
          :label-width="labelWidth"
          :label="$t('p0403.studyReportDateAndTime')"
          prop="studyReportDateAndTime"
        >
          <el-select
            v-model="newAnnouncementForm.studyReportDateAndTime"
            size="small"
            style="width: 80%"
            filterable
            clearable
            :placeholder="$t('common.pleaseSelect')"
          >
            <el-option
              v-for="(item, index) in classDateList2"
              :key="index"
              :label="item.courseDate"
              :value="item.courseDate"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="foot-container">
        <el-button type="submit" @click="enterReplaceStudyReportLink">{{
          $t("common.confirm")
        }}</el-button>
        <el-button type="return" @click="returnBack(6)">{{
          $t("common.back")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 课程二维码名称选框 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('p0403.courseCode')"
      width="600px"
      :visible.sync="courseCodeDialogFormVisible"
      @close="returnBack(7)"
    >
      <el-form
        :model="newAnnouncementForm"
        ref="newAnnouncementForm7"
        :hide-required-asterisk="true"
      >
        <!-- 课程名称 -->
        <el-form-item
          :label-width="labelWidth"
          :label="$t('p0403.courseCodeCourseNumber')"
          prop="courseCodeCourseNumber"
        >
          <el-select
            v-model="newAnnouncementForm.courseCodeCourseNumber"
            size="small"
            filterable
            clearable
            style="width: 80%"
            :placeholder="$t('common.pleaseSelect')"
          >
            <el-option
              v-for="item in courseNameList"
              :key="item.courseNumber"
              :label="item.courseName"
              :value="item.courseName"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="foot-container">
        <el-button type="submit" @click="replaceCourseCodeCourseNumber">{{
          $t("common.confirm")
        }}</el-button>
        <el-button type="return" @click="returnBack(7)">{{
          $t("common.back")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 课程报名二维码选框 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('p0403.courseEnrollCode')"
      width="600px"
      :visible.sync="courseEnrollCodesDialogFormVisible"
      @close="returnBack(8)"
    >
      <el-form
        :model="newAnnouncementForm"
        ref="newAnnouncementForm8"
        :hide-required-asterisk="true"
      >
        <!-- 课程名称 -->
        <el-form-item
          :label-width="labelWidth"
          :label="$t('p0403.courseEnrollCodeCourseNumber')"
          prop="courseEnrollCodeCourseNumber"
        >
          <el-select
            v-model="newAnnouncementForm.courseEnrollCodeCourseNumber"
            size="small"
            filterable
            clearable
            @change="replaceCourseEnrollCourseNumber"
            style="width: 80%"
            :placeholder="$t('common.pleaseSelect')"
          >
            <el-option
              v-for="item in courseNameList"
              :key="item.courseNumber"
              :label="item.courseName"
              :value="item.courseName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 排课日期时间 -->
        <el-form-item
          :label-width="labelWidth"
          :label="$t('p0403.courseEnrollCodeDateAndTime')"
          prop="courseEnrollCodeDateAndTime"
        >
          <el-select
            v-model="newAnnouncementForm.courseEnrollCodeDateAndTime"
            size="small"
            style="width: 80%"
            filterable
            clearable
            :placeholder="$t('common.pleaseSelect')"
          >
            <el-option
              v-for="(item, index) in classDateList3"
              :key="index"
              :label="item.courseDate"
              :value="item.courseDate"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="foot-container">
        <el-button
          type="submit"
          @click="enterReplaceCourseEnrollCourseNumber"
          >{{ $t("common.confirm") }}</el-button
        >
        <el-button type="return" @click="returnBack(8)">{{
          $t("common.back")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 视频回放二维码选框 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('p0403.videoCode')"
      width="600px"
      :visible.sync="videoCodeDialogFormVisible"
      @close="returnBack(9)"
    >
      <el-form
        :model="newAnnouncementForm"
        ref="newAnnouncementForm9"
        :hide-required-asterisk="true"
      >
        <!-- 课程名称 -->
        <el-form-item
          :label-width="labelWidth"
          :label="$t('p0403.videoCodeCourseNumber')"
          prop="videoCodeCourseNumber"
        >
          <el-select
            v-model="newAnnouncementForm.videoCodeCourseNumber"
            size="small"
            filterable
            clearable
            @change="replaceVideoCodeCourseNumber"
            style="width: 80%"
            :placeholder="$t('common.pleaseSelect')"
          >
            <el-option
              v-for="item in courseNameList"
              :key="item.courseNumber"
              :label="item.courseName"
              :value="item.courseName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 排课日期时间 -->
        <el-form-item
          :label-width="labelWidth"
          :label="$t('p0403.videoCodeDateAndTime')"
          prop="videoCodeDateAndTime"
        >
          <el-select
            v-model="newAnnouncementForm.videoCodeDateAndTime"
            size="small"
            style="width: 80%"
            filterable
            clearable
            :placeholder="$t('common.pleaseSelect')"
          >
            <el-option
              v-for="(item, index) in classDateList4"
              :key="index"
              :label="item.courseDate"
              :value="item.courseDate"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="foot-container">
        <el-button type="submit" @click="enterReplaceVideoCodeCourseNumber">{{
          $t("common.confirm")
        }}</el-button>
        <el-button type="return" @click="returnBack(9)">{{
          $t("common.back")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 视频回放推广二维码选框 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('p0403.videoCodePromote')"
      width="600px"
      :visible.sync="videoCodePromoteDialogFormVisible"
      @close="returnBack(10)"
    >
      <el-form
        :model="newAnnouncementForm"
        ref="newAnnouncementForm10"
        :hide-required-asterisk="true"
      >
        <!-- 课程名称 -->
        <el-form-item
          :label-width="labelWidth"
          :label="$t('p0403.videoCodePromoteCourseNumber')"
          prop="videoCodePromoteCourseNumber"
        >
          <el-select
            v-model="newAnnouncementForm.videoCodePromoteCourseNumber"
            size="small"
            filterable
            clearable
            @change="replaceVideoCodePromoteCourseNumber"
            style="width: 80%"
            :placeholder="$t('common.pleaseSelect')"
          >
            <el-option
              v-for="item in courseNameList"
              :key="item.courseNumber"
              :label="item.courseName"
              :value="item.courseName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 排课日期时间 -->
        <el-form-item
          :label-width="labelWidth"
          :label="$t('p0403.videoCodePromoteDateAndTime')"
          prop="videoCodePromoteDateAndTime"
        >
          <el-select
            v-model="newAnnouncementForm.videoCodePromoteDateAndTime"
            size="small"
            style="width: 80%"
            filterable
            clearable
            :placeholder="$t('common.pleaseSelect')"
          >
            <el-option
              v-for="(item, index) in classDateList5"
              :key="index"
              :label="item.courseDate"
              :value="item.courseDate"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="foot-container">
        <el-button
          type="submit"
          @click="enterReplaceVideoCodePromoteCourseNumber"
          >{{ $t("common.confirm") }}</el-button
        >
        <el-button type="return" @click="returnBack(10)">{{
          $t("common.back")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 生成课程链接选框 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="genLinkTitle"
      width="600px"
      @close="restoreLink"
      :visible.sync="courseNameLinkDialogFormVisible"
    >
      <el-form
        :model="courseLinkForm"
        ref="courseLinkForm"
        :hide-required-asterisk="true"
        :rules="rules"
      >
        <el-radio-group
          v-model="courseLinkForm.radioSelect"
          @change="clearCourseLinkForm"
        >
          <el-radio label="1">{{ $t("p0403.couLink") }}</el-radio>
          <el-radio label="2">{{ $t("p0403.phoLink") }}</el-radio>
          <el-radio label="3">{{ $t("p0403.freeLink") }}</el-radio>
        </el-radio-group>
        <!-- 课程链接选框 -->
        <div
          style="margin-top: 20px"
          v-if="courseLinkForm.radioSelect === '1' && showLinkFlag"
        >
          <!-- 课程名称 -->
          <el-form-item
            label-width="100px"
            :label="$t('p0403.selectCourseName')"
            prop="courseName"
          >
            <el-select
              v-model="courseLinkForm.courseName"
              size="small"
              filterable
              clearable
              style="width: 95%"
              :placeholder="$t('common.pleaseSelect')"
            >
              <el-option
                v-for="item in courseNameList"
                :key="item.courseName"
                :label="item.courseName"
                :value="item.courseName"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 课程链接 -->
          <el-form-item
            v-if="courseLinkForm.courseLink != ''"
            label-width="100px"
            :label="$t('p0403.courseLink')"
          >
            <el-input
              style="width: 95%"
              type="textarea"
              size="noticeContentInput"
              :rows="3"
              disabled
              v-model="courseLinkForm.courseLink"
            ></el-input>
          </el-form-item>
        </div>
        <!-- 图片选框 -->
        <div
          style="margin-top: 20px"
          v-if="courseLinkForm.radioSelect === '2' && showLinkFlag"
        >
          <autoUploadFile
            ref="autoUploadRef"
            :uploadImgStyle="0"
            @getImgInfo="getImgInfo"
            :imgIndex="-2"
            @deleteFile="deleteFile"
          />
        </div>
        <!-- 自由链接选框 -->
        <div
          style="margin-top: 20px"
          v-if="courseLinkForm.radioSelect === '3' && showLinkFlag"
        >
          <!-- 自由链接 -->
          <el-form-item label-width="0px" prop="courseLink">
            <el-input
              type="textarea"
              size="noticeContentInput"
              :placeholder="$t('p0403.enterLink')"
              :rows="5"
              v-model="courseLinkForm.courseLink"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div class="foot-container">
        <el-button type="submit" @click="replaceCourseNameLink">{{
          $t("common.confirm")
        }}</el-button>
        <el-button type="return" @click="restoreLink">{{
          $t("common.back")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 排课日期时间选框 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('p0403.selectDateAndTime')"
      width="600px"
      @close="returnBack(3)"
      :visible.sync="courseDateDialogFormVisible"
    >
      <el-form
        :model="newAnnouncementForm"
        ref="newAnnouncementForm2"
        :hide-required-asterisk="true"
      >
        <!-- 排课日期时间 -->
        <el-form-item
          :label-width="labelWidth"
          :label="$t('p0403.dateAndTime')"
          prop="courseDate"
        >
          <el-select
            v-model="newAnnouncementForm.courseDate"
            size="small"
            style="width: 80%"
            filterable
            clearable
            :placeholder="$t('common.pleaseSelect')"
          >
            <el-option
              v-for="(item, index) in classDateList"
              :key="index"
              :label="item.courseDate"
              :value="item.courseDate"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="foot-container">
        <el-button type="submit" @click="replaceCourseDate">{{
          $t("common.confirm")
        }}</el-button>
        <el-button type="return" @click="returnBack(3)">{{
          $t("common.back")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 公司选框 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('p0403.selectCompany')"
      @close="returnBack(4)"
      width="600px"
      :visible.sync="companyDialogFormVisible"
    >
      <el-form
        :model="newAnnouncementForm"
        ref="newAnnouncementForm3"
        :hide-required-asterisk="true"
      >
        <!-- 公司 -->
        <el-form-item
          :label-width="labelWidth"
          :label="$t('p0403.company')"
          prop="companyName"
        >
          <el-select
            v-model="newAnnouncementForm.companyName"
            size="small"
            style="width: 80%"
            filterable
            clearable
          >
            <el-option
              v-for="(item, index) in companyList"
              :key="index"
              :label="item.companyName"
              :value="item.companyName"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="foot-container">
        <el-button type="submit" @click="replaceCompany">{{
          $t("common.confirm")
        }}</el-button>
        <el-button type="return" @click="returnBack(4)">{{
          $t("common.back")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 地点选框 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('p0403.selectAddress')"
      width="600px"
      @close="returnBack(5)"
      :visible.sync="addressDialogFormVisible"
    >
      <el-form
        :model="newAnnouncementForm"
        ref="newAnnouncementForm4"
        :hide-required-asterisk="true"
      >
        <!-- 地点 -->
        <el-form-item
          :label-width="labelWidth"
          :label="$t('p0403.address')"
          prop="address"
        >
          <el-input
            size="small"
            style="width: 80%"
            :placeholder="$t('p0213.pleaseEnter')"
            v-model="newAnnouncementForm.address"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div class="foot-container">
        <el-button type="submit" @click="replaceAddress">{{
          $t("common.confirm")
        }}</el-button>
        <el-button type="return" @click="returnBack(5)">{{
          $t("common.back")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 预览选框 -->
    <el-dialog
      :title="$t('p0403.preview')"
      width="1000px"
      style="text-align:left;"
      :visible.sync="previewDialogFormVisible"
    >
      <div v-html="previewNoticeContent"></div>
      <div class="foot-container">
        <!-- <el-button type="submit" @click="previewDialogFormVisible = false">{{
          $t("common.confirm")
        }}</el-button> -->
        <el-button type="return" @click="previewDialogFormVisible = false">{{
          $t("common.back")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import uploadFile from "@/components/Common/UploadAttachment.vue";
import autoUploadFile from "@/components/Common/AutoUploadImg.vue";
import uploadImg from "@/components/Common/UploadImg.vue";
import Editor from "@/components/imcoder-tinymce";
import { build20Id } from "@/utils/buildId.js";
export default {
  components: {
    Editor,
    uploadFile,
    uploadImg,
    autoUploadFile
  },
  props: {
    dialogImageUrl: String
  },
  data() {
    return {
      // 用于刷新链接
      showLinkFlag: true,
      // 课程链接弹框
      courseLinkForm: {
        courseName: "",
        courseLink: "",
        // 默认选择课程链接
        radioSelect: "1"
      },
      // 生成链接标题
      genLinkTitle: "",
      // 课程链接弹框
      courseNameLinkDialogFormVisible: false,
      //  预览的内容
      previewNoticeContent: null,
      // 预览弹框
      previewDialogFormVisible: false,
      // 可添加模板form
      imgTemplateForm: [
        {
          // 图片url
          imgUrl: "",
          // 小标题
          inputTitle: "",
          // 内容
          inputContent: "",
          file: null,
          // 小标题拼课程链接
          inputTitleLink: "",
          // 课名
          courseName: "",
          // 链接选择项
          radioSelect: "",
          linkImgInfo: {}
        }
      ],
      // 可添加模板form项
      imgTemplateItem: {
        // 图片url
        imgUrl: "",
        // 小标题
        inputTitle: "",
        // 内容
        inputContent: "",
        file: null,
        // 小标题拼课程链接
        inputTitleLink: "",
        // 课名
        courseName: "",
        // 链接选择项
        radioSelect: "",
        linkImgInfo: {}
      },
      uploadImgStyle: 0,
      // 上传按钮控件是否显示按钮（重新加载用）
      uploadFileReloadFlag: true,
      // 上传按钮显示标志
      uploadBtnDisplayFlag: true,
      // 位置关联Code
      locationCode: build20Id(),
      // uploadButtonStyle: 3,
      saveFlag: false,
      // 群名称
      groupName: "",
      // Email群id
      emailGroupId: null,
      // 绿夹克上课名称列表
      courseNameList: [],
      // 公司列表
      companyList: [],
      selectList: [],
      // 中英文选项
      checkList: [],
      // 课名选项按钮
      courseNameView: false,
      // 日期与时间选项按钮
      dateAndTimeView: false,
      // 公司选项按钮
      companyView: false,
      // 地点选项按钮
      addressView: false,
      // 学习报告链接按钮
      studyReportLinkView: false,
      // 课程二维码按钮
      courseCodeView: false,
      // 课程报名二维码按钮
      courseEnrollCodeView: false,
      // 视频回放二维码按钮
      videoCodeView: false,
      // 视频回放推广二维码按钮
      videoCodePromoteView: false,
      // 公告模板form
      templateForm: {
        templateLabel: "",
        textarea: ""
      },
      // 绿夹克上课日期
      classDateList: [],
      // 学习报告上课日期
      classDateList2: [],
      // 课程报名二维码上课日期
      classDateList3: [],
      // 视频回放二维码上课日期
      classDateList4: [],
      // 视频回放推广二维码上课日期
      classDateList5: [],
      options: [
        {
          value: "0",
          label: "自由模板"
        },
        {
          value: "1",
          label: "模板一"
        }
      ],
      // 模板flag
      templateValue: "0",
      // 选择模板弹框
      templateFormVisible: false,
      // 选择模板下拉框
      noticeTemplateList: [],
      // 文件列表
      fileList: [],
      // 优惠码标签
      // couponLabel:
      //   this.$t("p0403.content1") +
      //   this.couponCode +
      //   this.$t("p0403.content2") +
      //   this.couponAmount +
      //   this.$t("p0403.content3"),
      // couponCode: "您的优惠码是【优惠码】，用于本次报名可以直接抵扣【金额】元。",
      // couponAmount: "【金额】",
      // 富文本框
      // yourContent: "",
      // 变量校验规则
      rules: {
        courseName: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: this.$t("p0403.pleaseSelectCourseName")
          }
        ],
        courseDate: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: this.$t("p0403.pleaseSelectDateAndTime")
          }
        ],
        companyName: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: this.$t("p0403.pleaseSelectCompany")
          }
        ],
        address: [
          {
            required: true,
            trigger: "blur",
            message: this.$t("p0403.pleaseSelectAddress")
          }
        ],
        courseLink: [
          {
            required: true,
            message: this.$t("p0403.enterLink"),
            trigger: ["blur", "change"]
          },
          {
            pattern: /^(http|https):\/\/([\w-]+\.)+[\w-]+(\/[\w-./#?%&=]*)?$/,
            message: this.$t("schedulingAndPricing.linkFormatIsIncorrect"),
            trigger: ["blur", "change"]
          }
        ]
      },
      // 标签宽度
      labelWidth: "180px",
      // 课程名称弹框
      courseNameDialogFormVisible: false,
      // 课程名称弹框
      courseDateDialogFormVisible: false,
      // 公司名称弹框
      companyDialogFormVisible: false,
      // 地点弹框
      addressDialogFormVisible: false,
      // 学习报告链接弹框
      studyReportLinkDialogFormVisible: false,
      // 课程二维码弹框
      courseCodeDialogFormVisible: false,
      // 课程报名二维码弹框
      courseEnrollCodesDialogFormVisible: false,
      // 视频回放二维码弹框
      videoCodeDialogFormVisible: false,
      // 视频回放推广二维码弹框
      videoCodePromoteDialogFormVisible: false,
      tempAnnouncementForm: {
        courseName: "",
        courseDate: "",
        address: "",
        companyName: "",
        studyReportCourseNumber: "",
        studyReportDateAndTime: "",
        courseCodeCourseNumber: "",
        courseEnrollCodeCourseNumber: "",
        courseEnrollCodeDateAndTime: "",
        videoCodeCourseNumber: "",
        videoCodeDateAndTime: "",
        videoCodePromoteCourseNumber: "",
        videoCodePromoteDateAndTime: ""
      },
      // 主题
      announcement: {
        emailTitle: ""
      },
      // 模板1变量
      template1Form: {
        topic: "",
        longImgUrl: "",
        editorA: "",
        editorB: ""
      },
      // 长图文件信息
      longImgInfo: [],
      // 链接图片信息
      linkImgInfoTemp: {},
      courseLinkFormTemp: {
        courseName: "",
        courseLink: "",
        linkImgInfo: {}
      },
      shortImgInfo: [
        {
          file: null,
          // 图片url
          imgUrl: "",
          // 小标题
          inputTitle: "",
          // 内容
          inputContent: ""
        }
      ],
      // 临时index
      tempIndex: "",
      tempTitle: "",
      // 判断是否全员公告
      noticeAllFlag: false,
      // 自由模板
      newAnnouncementForm: {
        type: [],
        desc: "",
        yourContent: "",
        courseName: "",
        courseDate: "",
        companyName: "",
        studyReportCourseNumber: "",
        studyReportDateAndTime: "",
        courseCodeCourseNumber: "",
        courseEnrollCodeCourseNumber: "",
        courseEnrollCodeDateAndTime: "",
        videoCodeCourseNumber: "",
        videoCodeDateAndTime: "",
        videoCodePromoteCourseNumber: "",
        videoCodePromoteDateAndTime: "",
        address: "",
        couponCodeZh:
          "您的优惠码是【优惠码】，用于本次报名可以直接抵扣【金额】。",
        couponCodeEn:
          "Your promotion code is [Coupon code]. Use the promotion code, you will get a discount of [Amount] for this registration."
        // couponAmount: "【金额】"
      }
    };
  },
  // 监听
  watch: {
    // // 监听富文本框内容长度
    // "newAnnouncementForm.yourContent.length": function(val) {
    //   if (val > 5000) {
    //     this.contentWarn();
    //   } else {
    //     this.$notify.closeAll()
    //   }
    // },
    // 监听公告模板的变量值
    // "newAnnouncementForm.desc": function(val) {
    //   let courseNameCheck = /\【课名】/g;
    //   let dateAndTimeCheck = /\【日期与时间】/g;
    //   let companyCheck = /\【公司】/g;
    //   let addressCheck = /\【地点】/g;
    //   // 控制课名按钮
    //   if (val.match(courseNameCheck)) {
    //     // this.courseNameView = true;
    //     // this.getCourseNameList();
    //   } else {
    //     this.courseNameView = false;
    //   }
    //   // 日期与时间按钮
    //   if (val.match(dateAndTimeCheck)) {
    //     // this.dateAndTimeView = true;
    //     // this.getCompanyList();
    //   } else {
    //     this.dateAndTimeView = false;
    //   }
    //   // 公司按钮
    //   if (val.match(companyCheck)) {
    //     // this.companyView = true;
    //   } else {
    //     this.companyView = false;
    //   }
    //   // 地点按钮
    //   if (val.match(addressCheck)) {
    //     // this.addressView = true;
    //   } else {
    //     this.addressView = false;
    //   }
    // }
  },
  methods: {
    // 恢复对象和链接
    restoreLink() {
      // 恢复刚刚删除的图片
      this.imgTemplateForm[this.tempIndex].linkImgInfo = this.linkImgInfoTemp;
      this.courseNameLinkDialogFormVisible = false;
      // this.$nextTick(() => {
      //   this.$refs["courseLinkForm"].resetFields();
      // });
    },
    // 选择项变动时清空链接框
    clearCourseLinkForm() {
      this.courseLinkForm.courseName = "";
      this.courseLinkForm.courseLink = "";
      this.linkImgInfoTemp = this.imgTemplateForm[this.tempIndex].linkImgInfo;
      this.imgTemplateForm[this.tempIndex].linkImgInfo = {};
      this.showLinkFlag = false;
      this.$nextTick(() => {
        this.showLinkFlag = true;
      });
    },
    // 添加、修改链接
    addLink(index, title) {
      // 临时索引
      this.tempIndex = index;
      if (title === null || title === "") {
        this.$message.error(this.$t("p0403.pleaseEnterContent"));
        return;
      }
      this.getCourseNameList();
      // 临时链接
      if (this.imgTemplateForm[index].inputTitleLink != "") {
        this.genLinkTitle = this.$t("p0403.updateLink");
        // 根据索引取出当前绑定项
        const {
          courseName,
          inputTitleLink,
          radioSelect,
          linkImgInfo
        } = this.imgTemplateForm[index];
        // 如果之前上传的是图片
        if (radioSelect === "2") {
          // console.log("inputTissstleLink", inputTitleLink);
          // 延时等待图片上传组件渲染
          setTimeout(() => {
            this.$refs["autoUploadRef"].setImgUrl({
              linkImgInfo,
              inputTitleLink,
              uploadFlag: false
            });
          }, 100);
        }
        // 赋值临时存储的数据
        this.courseLinkForm = {
          courseName: courseName,
          courseLink: inputTitleLink,
          radioSelect: radioSelect,
          linkImgInfo: linkImgInfo
        };
      } else {
        this.genLinkTitle = this.$t("p0403.addLink");
        this.courseLinkForm = {
          courseName: "",
          courseLink: "",
          // 默认选择课程链接
          radioSelect: "1",
          linkImgInfo: {}
        };
        this.$nextTick(() => {
          this.$refs["courseLinkForm"].clearValidate();
        });
      }
      // this.tempTitle = title;
      this.courseNameLinkDialogFormVisible = true;
      // 用于刷新弹框
      this.showLinkFlag = false;
      this.$nextTick(() => {
        this.showLinkFlag = true;
      });
      // if (index != 0) {
      //   this.$refs.courseLinkForm.courseName.clearValidate();
      // }
      // console.log("🚀 ~ file: P0405.vue:759 ~ addLink ~ title:", title);
      // console.log("🚀 ~ file: P0405.vue:759 ~ addLink ~ index:", index);
      // this.
    },
    // 创建课程链接
    async replaceCourseNameLink() {
      this.$refs.courseLinkForm.validate(async valid => {
        if (valid) {
          let linkFlag = this.courseLinkForm.radioSelect;
          if (linkFlag === "1") {
            let params = {
              field: this.courseLinkForm.courseName.substring(0, 2),
              category: this.courseLinkForm.courseName.substring(2, 4),
              courseNumber: this.courseLinkForm.courseName.substring(4, 6)
            };
            console.log(params);
            let url = "/api/emailGroupView/generateCourseLink";
            this.$http
              .post(url, params)
              .then(response => {
                if (response.data.code === 200) {
                  // 暂存生成的课程链接
                  this.imgTemplateForm[this.tempIndex].inputTitleLink =
                    response.data.data;
                  // 暂存生成的课程名称
                  this.imgTemplateForm[
                    this.tempIndex
                  ].courseName = this.courseLinkForm.courseName;
                  // 暂存选择项
                  this.imgTemplateForm[this.tempIndex].radioSelect = linkFlag;
                }
              })
              .catch(err => {
                console.log(err);
                this.$message.error(this.$t("common.anErrorOccurred"));
              });
          } else if (linkFlag === "2") {
            // 如果没有上传文件
            if (!this.imgTemplateForm[this.tempIndex].linkImgInfo.file) {
              this.$message.error(this.$t("p0403.enterImg"));
              return;
            }
            if (this.courseLinkForm.courseLink === "") {
              // 上传图片 获取图片链接
              await this.uploadImgFile(
                this.imgTemplateForm[this.tempIndex].linkImgInfo
              );
              // 暂存选择项
              this.imgTemplateForm[this.tempIndex].radioSelect = linkFlag;
            }
          } else {
            // 暂存选择项
            this.imgTemplateForm[this.tempIndex].radioSelect = linkFlag;
            // 暂存自定义链接
            this.imgTemplateForm[
              this.tempIndex
            ].inputTitleLink = this.courseLinkForm.courseLink;
          }
          this.courseNameLinkDialogFormVisible = false;
        }
      });
    },

    // 自由模板预览
    preview() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let params = {
        emailGroupId: this.emailGroupId,
        emailTitle: this.announcement.emailTitle,
        content: this.newAnnouncementForm.desc,
        couponFlag: this.checkList[0] ? "1" : "0",
        couponLanguage: this.checkList[0] ? this.checkList[0] : null,
        contentTemplateId: 0,
        body: this.newAnnouncementForm.yourContent,
        courseName: this.tempAnnouncementForm.courseName.substring(7),
        address: this.tempAnnouncementForm.address,
        companyName: this.tempAnnouncementForm.companyName,
        studyReportCourseNumber: this.tempAnnouncementForm.studyReportCourseNumber.substring(
          0,
          6
        ),
        studyReportDateAndTime: this.tempAnnouncementForm.studyReportDateAndTime
          ? this.tempAnnouncementForm.studyReportDateAndTime
          : null,
        courseCodeCourseNumber: this.tempAnnouncementForm.courseCodeCourseNumber.substring(
          0,
          6
        ),
        courseEnrollCodeCourseNumber: this.tempAnnouncementForm.courseEnrollCodeCourseNumber.substring(
          0,
          6
        ),
        courseEnrollCodeDateAndTime: this.tempAnnouncementForm
          .courseEnrollCodeDateAndTime
          ? this.tempAnnouncementForm.courseEnrollCodeDateAndTime
          : null,
        videoCodeCourseNumber: this.tempAnnouncementForm.videoCodeCourseNumber.substring(
          0,
          6
        ),
        videoCodeDateAndTime: this.tempAnnouncementForm.videoCodeDateAndTime
          ? this.tempAnnouncementForm.videoCodeDateAndTime
          : null,
        videoCodePromoteCourseNumber: this.tempAnnouncementForm.videoCodePromoteCourseNumber.substring(
          0,
          6
        ),
        videoCodePromoteDateAndTime: this.tempAnnouncementForm
          .videoCodePromoteDateAndTime
          ? this.tempAnnouncementForm.videoCodePromoteDateAndTime
          : null,
        field: this.tempAnnouncementForm.courseName.substring(0, 2),
        category: this.tempAnnouncementForm.courseName.substring(2, 4),
        courseNumber: this.tempAnnouncementForm.courseName.substring(4, 6),
        courseNumberTemp: this.tempAnnouncementForm.courseName.substring(0, 6),
        dateAndTime: this.tempAnnouncementForm.courseDate
          ? this.tempAnnouncementForm.courseDate
          : null,
        loginId: localStorage.getItem("userId"),
        locationCode: this.locationCode
      };
      console.log(params);
      let url = "/api/emailGroupView/previewNotice";
      this.$http
        .post(url, params)
        .then(response => {
          loading.close();
          if (response.data.code === 200) {
            if (response.data.message === "error") {
              this.warn(response.data.data);
            } else {
              this.previewNoticeContent = response.data.data;
              this.previewDialogFormVisible = true;
            }
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 模板一预览
    preview1() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let params = {
        emailGroupId: this.emailGroupId,
        emailTitle: this.announcement.emailTitle,
        content: this.newAnnouncementForm.desc,
        couponFlag: this.checkList[0] ? "1" : "0",
        couponLanguage: this.checkList[0] ? this.checkList[0] : null,
        contentTemplateId: 1,
        tempTopic: this.template1Form.topic,
        tempLongImg: this.template1Form.longImgUrl,
        editorA: this.template1Form.editorA,
        itemList: this.imgTemplateForm,
        editorB: this.template1Form.editorB,
        courseName: this.tempAnnouncementForm.courseName.substring(7),
        address: this.tempAnnouncementForm.address,
        companyName: this.tempAnnouncementForm.companyName,
        studyReportCourseNumber: this.tempAnnouncementForm.studyReportCourseNumber.substring(
          0,
          6
        ),
        studyReportDateAndTime: this.tempAnnouncementForm.studyReportDateAndTime
          ? this.tempAnnouncementForm.studyReportDateAndTime
          : null,
        courseCodeCourseNumber: this.tempAnnouncementForm.courseCodeCourseNumber.substring(
          0,
          6
        ),
        courseEnrollCodeCourseNumber: this.tempAnnouncementForm.courseEnrollCodeCourseNumber.substring(
          0,
          6
        ),
        courseEnrollCodeDateAndTime: this.tempAnnouncementForm
          .courseEnrollCodeDateAndTime
          ? this.tempAnnouncementForm.courseEnrollCodeDateAndTime
          : null,
        videoCodeCourseNumber: this.tempAnnouncementForm.videoCodeCourseNumber.substring(
          0,
          6
        ),
        videoCodeDateAndTime: this.tempAnnouncementForm.videoCodeDateAndTime
          ? this.tempAnnouncementForm.videoCodeDateAndTime
          : null,
        videoCodePromoteCourseNumber: this.tempAnnouncementForm.videoCodePromoteCourseNumber.substring(
          0,
          6
        ),
        videoCodePromoteDateAndTime: this.tempAnnouncementForm
          .videoCodePromoteDateAndTime
          ? this.tempAnnouncementForm.videoCodePromoteDateAndTime
          : null,
        field: this.tempAnnouncementForm.courseName.substring(0, 2),
        category: this.tempAnnouncementForm.courseName.substring(2, 4),
        courseNumber: this.tempAnnouncementForm.courseName.substring(4, 6),
        courseNumberTemp: this.tempAnnouncementForm.courseName.substring(0, 6),
        dateAndTime: this.tempAnnouncementForm.courseDate
          ? this.tempAnnouncementForm.courseDate
          : null,
        loginId: localStorage.getItem("userId")
      };
      // console.log(params);
      let url = "/api/emailGroupView/previewNotice";
      this.$http
        .post(url, params)
        .then(response => {
          loading.close();
          if (response.data.code === 200) {
            if (response.data.message === "error") {
              this.warn(response.data.data);
            } else {
              this.previewNoticeContent = response.data.data;
              this.previewDialogFormVisible = true;
            }
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 删除子组件值
    deleteFile(index) {
      // console.log("🚀 ~ file: P0405.vue:708 ~ deleteFile ~ index:", index);
      // await this.shortImgInfo.splice(index, 1);
      // for(let i = index; i< this.shortImgInfo.length; i++) {
      //   this.shortImgInfo[i].index = i;
      // }
      // this.$set(this.shortImgInfo[index],'file', null)
      if (index === -1) {
        this.longImgInfo.splice(index, 1);
        this.template1Form.longImgUrl = "";
      } else if (index === -2) {
        this.linkImgInfoTemp = this.imgTemplateForm[this.tempIndex].linkImgInfo;
        this.imgTemplateForm[this.tempIndex].linkImgInfo = {};
        this.courseLinkForm.courseLink = "";
      } else {
        this.shortImgInfo[index] = { ...this.shortImgInfo[index], file: null };
        this.imgTemplateForm[index].imgUrl = "";
      }

      // console.log(
      //   "🚀 ~ file: P0405.vue:712 ~ deleteFile ~ this.shortImgInfo[index]:",
      //   this.shortImgInfo[index]
      // );
    },
    //  获取上传图片信息
    getImgInfo(fileInfo) {
      // 长图
      if (fileInfo.index === -1) {
        this.longImgInfo.push({ ...fileInfo });
        this.template1Form.longImgUrl = fileInfo.url;
      } else if (fileInfo.index === -2) {
        // 链接图片信息
        this.imgTemplateForm[this.tempIndex].linkImgInfo = fileInfo;
      } else {
        // 方图
        this.shortImgInfo[fileInfo.index].file = fileInfo;
        this.imgTemplateForm[fileInfo.index].imgUrl = fileInfo.url;
      }
    },
    // 根据索引删除添加
    deleteImgTemplateItem(index) {
      // this.imgTemplateForm[index] = {
      //   // 图片url
      //   imgUrl: "",
      //   // 小标题
      //   inputTitle: "",
      //   // 内容
      //   inputContent: ""
      // };
      // this.deleteFile(index);
      let formName = "imgRef";
      for (let i = index; i + 1 < this.imgTemplateForm.length; i++) {
        let ref = this.$refs[formName + i];
        if (Array.isArray(ref)) {
          ref = ref[0];
        }
        let ref2 = this.$refs[formName + (i + 1)];
        if (Array.isArray(ref2)) {
          ref2 = ref2[0];
        }
        ref.setImgUrl(ref2.getImgUrl());
      }
      // this.deleteFile(index);
      this.imgTemplateForm.splice(index, 1);
    },
    // 添加小模板
    addimgTemplateForm() {
      this.imgTemplateForm.push({ ...this.imgTemplateItem });
      this.shortImgInfo.push({ ...this.imgTemplateItem });
    },
    selectBodyTemplate(tempValue) {},
    setMealSelect() {
      // 截取数组的最后一位,并从新赋值
      this.checkList = this.checkList.slice(-1);
    },
    // 附件提交
    async upload() {
      // 风险分析1
      await this.$refs.uploadCardFile_1.submitUploadFile();
    },
    // 改变上传文件的状态
    changeUploadFileStatus() {
      // console.log(this.uploadFile.uploadBtnDisplayFlag) //= !this.uploadFile.uploadBtnDisplayFlag;
      this.uploadBtnDisplayFlag = !this.uploadBtnDisplayFlag;
      this.reloadUploadFile();
    },
    // 发送成功通知
    open() {
      this.$alert(this.$t("p0403.sendSuccess"), this.$t("common.tips"), {
        confirmButtonText: this.$t("common.confirm"),
        callback: action => {}
      });
    },
    // 警告通知
    warn(info) {
      this.$alert(info, this.$t("common.warning"), {
        confirmButtonText: this.$t("common.confirm"),
        callback: action => {}
      });
    },
    // 内容超限警告
    contentWarn() {
      this.$alert(this.$t("p0403.checkContent"), this.$t("common.warning"), {
        confirmButtonText: this.$t("common.confirm"),
        callback: action => {}
      });
      // this.$notify({
      //   title: this.$t("common.warning"),
      //   message: this.$t("p0403.checkContent"),
      //   type: "warning",
      // });
    },
    // 重新加载上传附件控件
    async reloadUploadFile() {
      this.uploadFileReloadFlag = false;
      await this.$nextTick();
      this.uploadFileReloadFlag = true;
    },
    // 模板1发送通知
    async sendNotice1() {
      // console.log("announcement", this.announcement);
      // console.log("template1Form", this.template1Form);
      // console.log("newAnnouncementForm", this.newAnnouncementForm);
      // console.log("imgTemplateForm", this.imgTemplateForm);
      // console.log("templateValue", this.templateValue);
      // let url = "";
      // console.log(
      //   "🚀 ~ file: P0405.vue:787 ~ sendNotice1 ~ this.shortImgInfo:",
      //   this.shortImgInfo
      // );
      if (
        this.template1Form.editorA.length > 2621440 ||
        this.template1Form.editorB.length > 2621440
      ) {
        this.contentWarn();
      } else if (this.announcement.emailTitle.length === 0) {
        // console.log(this.announcement.emailTitle.length);
        // 主题校验
        this.$message.error(this.$t("p0403.pleaseEnterEmailTitle"));
      } else if (this.announcement.emailTitle.length > 200) {
        // 主题长度校验
        this.$message.error(this.$t("p0403.maxLength200"));
      } else {
        const loading = this.$loading({
          lock: true,
          text: this.$t("common.loading"),
          background: "rgba(255,255,255,0.8)",
          target: document.querySelector("#main-container")
        });
        // 如果长图存在
        if (this.longImgInfo.length > 0) {
          for (var i = 0; i < this.longImgInfo.length; i++) {
            await this.uploadImgFile(this.longImgInfo[i]);
          }
        }
        // 如果方图存在
        if (this.shortImgInfo.length > 0) {
          // console.log(
          //   "🚀 ~ file: P0405.vue:841 ~ sendNotice1 ~ this.shortImgInfo:",
          //   this.shortImgInfo
          // );
          for (var i = 0; i < this.shortImgInfo.length; i++) {
            if (this.shortImgInfo[i].file != null) {
              await this.uploadImgFile(this.shortImgInfo[i].file);
            }
          }
        }

        let params = {
          emailGroupId: this.emailGroupId,
          emailTitle: this.announcement.emailTitle,
          content: this.newAnnouncementForm.desc,
          couponFlag: this.checkList[0] ? "1" : "0",
          couponLanguage: this.checkList[0] ? this.checkList[0] : null,
          contentTemplateId: 1,
          tempTopic: this.template1Form.topic,
          tempLongImg: this.template1Form.longImgUrl,
          editorA: this.template1Form.editorA,
          itemList: this.imgTemplateForm,
          editorB: this.template1Form.editorB,
          courseName: this.tempAnnouncementForm.courseName.substring(7),
          address: this.tempAnnouncementForm.address,
          companyName: this.tempAnnouncementForm.companyName,
          studyReportCourseNumber: this.tempAnnouncementForm.studyReportCourseNumber.substring(
            0,
            6
          ),
          studyReportDateAndTime: this.tempAnnouncementForm
            .studyReportDateAndTime
            ? this.tempAnnouncementForm.studyReportDateAndTime
            : null,
          courseCodeCourseNumber: this.tempAnnouncementForm.courseCodeCourseNumber.substring(
            0,
            6
          ),
          courseEnrollCodeCourseNumber: this.tempAnnouncementForm.courseEnrollCodeCourseNumber.substring(
            0,
            6
          ),
          courseEnrollCodeDateAndTime: this.tempAnnouncementForm
            .courseEnrollCodeDateAndTime
            ? this.tempAnnouncementForm.courseEnrollCodeDateAndTime
            : null,
          videoCodeCourseNumber: this.tempAnnouncementForm.videoCodeCourseNumber.substring(
            0,
            6
          ),
          videoCodeDateAndTime: this.tempAnnouncementForm.videoCodeDateAndTime
            ? this.tempAnnouncementForm.videoCodeDateAndTime
            : null,
          videoCodePromoteCourseNumber: this.tempAnnouncementForm.videoCodePromoteCourseNumber.substring(
            0,
            6
          ),
          videoCodePromoteDateAndTime: this.tempAnnouncementForm
            .videoCodePromoteDateAndTime
            ? this.tempAnnouncementForm.videoCodePromoteDateAndTime
            : null,
          field: this.tempAnnouncementForm.courseName.substring(0, 2),
          category: this.tempAnnouncementForm.courseName.substring(2, 4),
          courseNumber: this.tempAnnouncementForm.courseName.substring(4, 6),
          courseNumberTemp: this.tempAnnouncementForm.courseName.substring(
            0,
            6
          ),
          dateAndTime: this.tempAnnouncementForm.courseDate
            ? this.tempAnnouncementForm.courseDate
            : null,
          loginId: localStorage.getItem("userId")
        };
        console.log(params);
        let url = "/api/emailGroupView/sendNotice";
        this.$http
          .post(url, params)
          .then(response => {
            loading.close();
            if (response.data.code === 200) {
              this.open(response.data.message);
            } else {
              // loading.close();
              this.warn(response.data.message);
            }
          })
          .catch(err => {
            console.log(err);
            loading.close();
            this.$message.error(this.$t("common.anErrorOccurred"));
          });
        // console.log("修改后this.imgTemplateForm", this.imgTemplateForm);
        // console.log("修改后this.template1Form", this.template1Form);
      }
    },
    // 模板1图片上传
    async uploadImgFile(file) {
      // console.log("🚀 ~ file: P0405.vue:777 ~ uploadImgFile ~ file:", file);
      const url = "/api/common/noticeUploadFile"; // 这个地址是请求接口的一个映射
      const formData = new FormData(); // 和后端协商后用formData格式进行传参
      formData.append("addFiles", file.file.raw);
      // 当前用户id
      formData.append("userId", localStorage.getItem("userId"));
      // 创建用户的ID
      formData.append("creatUser", localStorage.getItem("userId"));
      // 群公告ID（0:全员公告）
      formData.append("emailGroupId", this.emailGroupId);
      await this.$http
        .post(url, formData)
        .then(res => {
          // console.log(res);
          if (res.data.code === 200) {
            // console.log("上传图片成功");
            if (file.index === -1) {
              // 长图url赋值
              this.template1Form.longImgUrl = res.data.data;
            } else if (file.index === -2) {
              this.imgTemplateForm[this.tempIndex].inputTitleLink =
                res.data.data;
            } else {
              // 小模板变量赋值
              this.imgTemplateForm[file.index].imgUrl = res.data.data;
            }
          }
          //
        })
        .catch(err => {
          console.log("图片上传失败");
          console.log(err);
        });
    },
    // 发送通知
    async sendNotice() {
      // console.log("发送通知dsfdsg", this.newAnnouncementForm);
      if (this.newAnnouncementForm.yourContent.length > 5242880) {
        this.contentWarn();
      } else if (this.announcement.emailTitle.length === 0) {
        // console.log(this.announcement.emailTitle.length);
        // 主题校验
        this.$message.error(this.$t("p0403.pleaseEnterEmailTitle"));
      } else if (this.announcement.emailTitle.length > 200) {
        // 主题长度校验
        this.$message.error(this.$t("p0403.maxLength200"));
      } else {
        const loading = this.$loading({
          lock: true,
          text: this.$t("common.loading"),
          background: "rgba(255,255,255,0.8)",
          target: document.querySelector("#main-container")
        });
        await this.upload();
        if (this.$refs.uploadCardFile_1.uploadFileList.length == 0) {
          this.locationCode = null;
        }
        let params = {
          emailGroupId: this.emailGroupId,
          emailTitle: this.announcement.emailTitle,
          content: this.newAnnouncementForm.desc,
          couponFlag: this.checkList[0] ? "1" : "0",
          couponLanguage: this.checkList[0] ? this.checkList[0] : null,
          contentTemplateId: 0,
          body: this.newAnnouncementForm.yourContent,
          courseName: this.tempAnnouncementForm.courseName.substring(7),
          address: this.tempAnnouncementForm.address,
          companyName: this.tempAnnouncementForm.companyName,
          studyReportCourseNumber: this.tempAnnouncementForm.studyReportCourseNumber.substring(
            0,
            6
          ),
          studyReportDateAndTime: this.tempAnnouncementForm
            .studyReportDateAndTime
            ? this.tempAnnouncementForm.studyReportDateAndTime
            : null,
          courseCodeCourseNumber: this.tempAnnouncementForm.courseCodeCourseNumber.substring(
            0,
            6
          ),
          courseEnrollCodeCourseNumber: this.tempAnnouncementForm.courseEnrollCodeCourseNumber.substring(
            0,
            6
          ),
          courseEnrollCodeDateAndTime: this.tempAnnouncementForm
            .courseEnrollCodeDateAndTime
            ? this.tempAnnouncementForm.courseEnrollCodeDateAndTime
            : null,
          videoCodeCourseNumber: this.tempAnnouncementForm.videoCodeCourseNumber.substring(
            0,
            6
          ),
          videoCodeDateAndTime: this.tempAnnouncementForm.videoCodeDateAndTime
            ? this.tempAnnouncementForm.videoCodeDateAndTime
            : null,
          videoCodePromoteCourseNumber: this.tempAnnouncementForm.videoCodePromoteCourseNumber.substring(
            0,
            6
          ),
          videoCodePromoteDateAndTime: this.tempAnnouncementForm
            .videoCodePromoteDateAndTime
            ? this.tempAnnouncementForm.videoCodePromoteDateAndTime
            : null,
          field: this.tempAnnouncementForm.courseName.substring(0, 2),
          category: this.tempAnnouncementForm.courseName.substring(2, 4),
          courseNumber: this.tempAnnouncementForm.courseName.substring(4, 6),
          courseNumberTemp: this.tempAnnouncementForm.courseName.substring(
            0,
            6
          ),
          dateAndTime: this.tempAnnouncementForm.courseDate
            ? this.tempAnnouncementForm.courseDate
            : null,
          loginId: localStorage.getItem("userId"),
          locationCode: this.locationCode
        };
        // console.log(params);
        let url = "/api/emailGroupView/sendNotice";
        this.$http
          .post(url, params)
          .then(response => {
            loading.close();
            this.locationCode = build20Id();
            if (response.data.code === 200) {
              this.open(response.data.message);
            } else {
              loading.close();
              this.warn(response.data.message);
            }
          })
          .catch(err => {
            console.log(err);
            loading.close();
            this.$message.error(this.$t("common.anErrorOccurred"));
          });
      }
    },
    // 返回
    returnBack(num) {
      switch (num) {
        // 清空选择公告模板
        case 1:
          this.templateFormVisible = false;
          this.templateForm = {
            templateLabel: "",
            textarea: ""
          };
          break;
        case 2:
          // 清空课程名称
          this.courseNameDialogFormVisible = false;
          this.$refs.newAnnouncementForm1.resetFields();
          // this.newAnnouncementForm.courseName = "";
          break;
        case 3:
          // 清空课程日期
          this.courseDateDialogFormVisible = false;
          this.$refs.newAnnouncementForm2.resetFields();
          // this.newAnnouncementForm.courseDate = "";
          break;
        case 4:
          // 清空公司名称
          this.companyDialogFormVisible = false;
          this.$refs.newAnnouncementForm3.resetFields();
          // this.newAnnouncementForm.companyName = "";
          break;
        case 5:
          // 清空地址
          this.addressDialogFormVisible = false;
          this.$refs.newAnnouncementForm4.resetFields();
          // this.newAnnouncementForm.address = "";
          break;
        case 6:
          // 清空课程名称
          this.studyReportLinkDialogFormVisible = false;
          this.$refs.newAnnouncementForm6.resetFields();
          // this.newAnnouncementForm.courseName = "";
          break;
        case 7:
          // 清空课程二维码名称
          this.courseCodeDialogFormVisible = false;
          this.$refs.newAnnouncementForm7.resetFields();
          // this.newAnnouncementForm.courseName = "";
          break;
        case 8:
          // 清空课程报名二维码名称
          this.courseEnrollCodesDialogFormVisible = false;
          this.$refs.newAnnouncementForm8.resetFields();
          // this.newAnnouncementForm.courseName = "";
          break;
        case 9:
          // 清空视频回放二维码名称
          this.videoCodeDialogFormVisible = false;
          this.$refs.newAnnouncementForm9.resetFields();
          // this.newAnnouncementForm.courseName = "";
          break;
        case 10:
          // 清空视频回放二维码名称
          this.videoCodePromoteDialogFormVisible = false;
          this.$refs.newAnnouncementForm10.resetFields();
          // this.newAnnouncementForm.courseName = "";
          break;
        default:
          break;
      }
    },
    // 根据课程查询排课时间
    getScheduleByCourse(row, flag) {
      // console.log(row);
      let url = "/api/couponCode/getScheduleByCourse";
      this.$http
        .post(url, qs.stringify({ courseNumber: row }))
        .then(response => {
          if (response.data.code === 200) {
            if (flag === 1) {
              // 普通日期与时间
              this.classDateList = response.data.data;
            } else if (flag === 2) {
              // 学习报告链接日期与时间
              this.classDateList2 = response.data.data;
            } else if (flag === 3) {
              // 课程报名二维码日期与时间
              this.classDateList3 = response.data.data;
            } else if (flag === 4) {
              // 视频回放二维码日期与时间
              this.classDateList4 = response.data.data;
            } else if (flag === 5) {
              this.classDateList5 = response.data.data;
            } else {
              this.classDateList = response.data.data;
            }
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 获取课程名称列表
    getCourseNameList() {
      let url = "/api/emailGroupView/getCourseNameList";
      this.$http
        .get(url)
        .then(response => {
          // 课程名称下拉框数据
          this.courseNameList = response.data.data;
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("p0211.errorOccurred"));
        });
    },
    // 获取公司列表
    getCompanyList() {
      let url = "/api/emailGroupView/getCompanyList";
      this.$http
        .get(url)
        .then(response => {
          // 课程名称下拉框数据
          this.companyList = response.data.data;
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("p0211.errorOccurred"));
        });
    },
    // 查询公告模板内容
    getNoticeTemplateContent(row) {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector(".el-dialog__body")
      });
      this.courseNameList = [];
      this.classDateList = [];
      this.classDateList2 = [];
      this.classDateList3 = [];
      this.classDateList4 = [];
      this.classDateList5 = [];
      this.companyList = [];

      // this.tempAnnouncementForm = {
      //   courseName: "",
      //   courseDate: "",
      //   companyName: "",
      //   address: ""
      // };
      // console.log(row);
      let url = "/api/emailGroupView/getNoticeTemplateContent";
      this.$http
        .post(url, qs.stringify({ templateId: row }))
        .then(response => {
          if (response.data.code === 200) {
            this.templateForm.textarea = response.data.data;
            loading.close();
          } else {
            loading.close();
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 查询选择模板下拉框信息
    async getNoticeTemplateList() {
      // 选择模板下拉框
      await this.selectNoticeTemplateList();
      this.templateFormVisible = true;
    },
    // 选择模板下拉框
    selectNoticeTemplateList() {
      let url = "/api/emailGroupView/getNoticeTemplateList";
      this.$http
        .get(url)
        .then(response => {
          if (response.data.code === 200) {
            this.noticeTemplateList = response.data.data;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 普通课名弹框
    courseNameDialog() {
      this.newAnnouncementForm.courseName = this.tempAnnouncementForm.courseName;
      this.courseNameDialogFormVisible = true;
      // this.newAnnouncementForm.studyReportCourseNumber = this.tempAnnouncementForm.studyReportCourseNumber;
    },
    // 普通日期与时间弹框
    courseDateDialog() {
      this.newAnnouncementForm.courseDate = this.tempAnnouncementForm.courseDate;
      // this.newAnnouncementForm.studyReportDateAndTime = this.tempAnnouncementForm.studyReportDateAndTime;
      this.courseDateDialogFormVisible = true;
    },
    // 公司弹框
    companyDialog() {
      this.newAnnouncementForm.companyName = this.tempAnnouncementForm.companyName;
      this.companyDialogFormVisible = true;
    },
    // 地址弹框
    addressDialog() {
      this.newAnnouncementForm.address = this.tempAnnouncementForm.address;
      this.addressDialogFormVisible = true;
    },
    // 学习报告链接弹框
    studyReportLinkDialog() {
      this.newAnnouncementForm.studyReportDateAndTime = this.tempAnnouncementForm.studyReportDateAndTime;
      this.newAnnouncementForm.studyReportCourseNumber = this.tempAnnouncementForm.studyReportCourseNumber;
      this.studyReportLinkDialogFormVisible = true;
    },
    // 课程二维码弹框
    courseCodeDialog() {
      this.newAnnouncementForm.courseCodeCourseNumber = this.tempAnnouncementForm.courseCodeCourseNumber;
      this.courseCodeDialogFormVisible = true;
    },
    // 课程二维码弹框
    courseEnrollCodesDialog() {
      this.newAnnouncementForm.courseEnrollCodeCourseNumber = this.tempAnnouncementForm.courseEnrollCodeCourseNumber;
      this.newAnnouncementForm.courseEnrollCodeDateAndTime = this.tempAnnouncementForm.courseEnrollCodeDateAndTime;
      this.courseEnrollCodesDialogFormVisible = true;
    },
    // 视频回放弹框
    videoCodeDialog() {
      this.newAnnouncementForm.videoCodeCourseNumber = this.tempAnnouncementForm.videoCodeCourseNumber;
      this.newAnnouncementForm.videoCodeDateAndTime = this.tempAnnouncementForm.videoCodeDateAndTime;
      this.videoCodeDialogFormVisible = true;
    },
    // 视频回放推广弹框
    videoCodePromoteDialog() {
      this.newAnnouncementForm.videoCodePromoteCourseNumber = this.tempAnnouncementForm.videoCodePromoteCourseNumber;
      this.newAnnouncementForm.videoCodePromoteDateAndTime = this.tempAnnouncementForm.videoCodePromoteDateAndTime;
      this.videoCodePromoteDialogFormVisible = true;
    },
    // 替换课程名称
    replaceCourseName() {
      // this.$refs.newAnnouncementForm1.validateField("courseName", valid => {
      //   if (!valid) {
      if (
        this.newAnnouncementForm.courseName !=
        this.tempAnnouncementForm.courseName
      ) {
        this.tempAnnouncementForm.courseName = this.newAnnouncementForm.courseName;
        this.getScheduleByCourse(this.newAnnouncementForm.courseName, 1);
        this.tempAnnouncementForm.courseDate = "";
        this.newAnnouncementForm.courseDate = "";
      }
      this.courseNameDialogFormVisible = false;
      // this.courseNameView = false;
      // }
      // });
    },
    // 替换排课日期与时间
    replaceCourseDate() {
      // this.$refs.newAnnouncementForm2.validateField("courseDate", valid => {
      //   if (!valid) {
      this.tempAnnouncementForm.courseDate = this.newAnnouncementForm.courseDate;
      // let dateAndTimeCheck = /\【日期与时间】/g;
      // this.newAnnouncementForm.desc = this.newAnnouncementForm.desc.replace(
      //   dateAndTimeCheck,
      //   this.newAnnouncementForm.courseDate
      // );
      this.courseDateDialogFormVisible = false;
      // this.dateAndTimeView = false;
      //   }
      // });
    },
    // 替换公司
    replaceCompany() {
      // this.$refs.newAnnouncementForm3.validateField("companyName", valid => {
      //   if (!valid) {
      this.tempAnnouncementForm.companyName = this.newAnnouncementForm.companyName;
      // let companyCheck = /\【公司】/g;
      // this.newAnnouncementForm.desc = this.newAnnouncementForm.desc.replace(
      //   companyCheck,
      //   this.newAnnouncementForm.companyName
      // );
      this.companyDialogFormVisible = false;
      // this.companyView = false;
      //   }
      // });
    },
    // 替换地点
    replaceAddress() {
      // this.$refs.newAnnouncementForm4.validateField("address", valid => {
      //   if (!valid) {
      this.tempAnnouncementForm.address = this.newAnnouncementForm.address;
      // let addressCheck = /\【地点】/g;
      // this.newAnnouncementForm.desc = this.newAnnouncementForm.desc.replace(
      //   addressCheck,
      //   this.newAnnouncementForm.address
      // );
      this.addressDialogFormVisible = false;
      // this.addressView = false;
      //   }
      // });
    },
    // 替换学习报告链接课名
    replaceStudyReportLink() {
      // this.$refs.newAnnouncementForm4.validateField("address", valid => {
      //   if (!valid) {
      // this.tempAnnouncementForm.studyReportCourseNumber = this.newAnnouncementForm.studyReportCourseNumber;
      if (
        this.newAnnouncementForm.studyReportCourseNumber !=
        this.tempAnnouncementForm.studyReportCourseNumber
      ) {
        // this.tempAnnouncementForm.studyReportCourseNumber = this.newAnnouncementForm.studyReportCourseNumber;
        this.getScheduleByCourse(
          this.newAnnouncementForm.studyReportCourseNumber,
          2
        );
        // this.tempAnnouncementForm.studyReportDateAndTime = this.newAnnouncementForm.studyReportDateAndTime;
        this.tempAnnouncementForm.studyReportDateAndTime = "";
        this.newAnnouncementForm.studyReportDateAndTime = "";
      }
    },
    // 替换学习报告链接课名
    enterReplaceStudyReportLink() {
      // this.$refs.newAnnouncementForm4.validateField("address", valid => {
      //   if (!valid) {
      // this.tempAnnouncementForm.studyReportCourseNumber = this.newAnnouncementForm.studyReportCourseNumber;
      this.tempAnnouncementForm.studyReportCourseNumber = this.newAnnouncementForm.studyReportCourseNumber;
      this.tempAnnouncementForm.studyReportDateAndTime = this.newAnnouncementForm.studyReportDateAndTime;
      // this.tempAnnouncementForm.studyReportDateAndTime = "";
      // this.newAnnouncementForm.studyReportDateAndTime = "";
      // let addressCheck = /\【地点】/g;
      // this.newAnnouncementForm.desc = this.newAnnouncementForm.desc.replace(
      //   addressCheck,
      //   this.newAnnouncementForm.address
      // );
      this.studyReportLinkDialogFormVisible = false;
      // this.addressView = false;
      //   }
      // });
    },
    // 替换课程二维码名称
    replaceCourseCodeCourseNumber() {
      // this.$refs.newAnnouncementForm1.validateField("courseName", valid => {
      //   if (!valid) {
      this.tempAnnouncementForm.courseCodeCourseNumber = this.newAnnouncementForm.courseCodeCourseNumber;
      this.courseCodeDialogFormVisible = false;
      // this.courseNameView = false;
      // }
      // });
    },
    // 课程报名二维码课名
    replaceCourseEnrollCourseNumber() {
      if (
        this.newAnnouncementForm.courseEnrollCodeCourseNumber !=
        this.tempAnnouncementForm.courseEnrollCodeCourseNumber
      ) {
        this.getScheduleByCourse(
          this.newAnnouncementForm.courseEnrollCodeCourseNumber,
          3
        );
        this.tempAnnouncementForm.courseEnrollCodeDateAndTime = "";
        this.newAnnouncementForm.courseEnrollCodeDateAndTime = "";
      }
    },
    // 替换课程报名二维码课名
    enterReplaceCourseEnrollCourseNumber() {
      this.tempAnnouncementForm.courseEnrollCodeCourseNumber = this.newAnnouncementForm.courseEnrollCodeCourseNumber;
      this.tempAnnouncementForm.courseEnrollCodeDateAndTime = this.newAnnouncementForm.courseEnrollCodeDateAndTime;
      this.courseEnrollCodesDialogFormVisible = false;
    },
    // 视频回放二维码课名
    replaceVideoCodeCourseNumber() {
      if (
        this.newAnnouncementForm.videoCodeCourseNumber !=
        this.tempAnnouncementForm.videoCodeCourseNumber
      ) {
        this.getScheduleByCourse(
          this.newAnnouncementForm.videoCodeCourseNumber,
          4
        );
        this.tempAnnouncementForm.videoCodeDateAndTime = "";
        this.newAnnouncementForm.videoCodeDateAndTime = "";
      }
    },
    // 替换视频回放二维码课名
    enterReplaceVideoCodeCourseNumber() {
      this.tempAnnouncementForm.videoCodeCourseNumber = this.newAnnouncementForm.videoCodeCourseNumber;
      this.tempAnnouncementForm.videoCodeDateAndTime = this.newAnnouncementForm.videoCodeDateAndTime;
      this.videoCodeDialogFormVisible = false;
    },
    // 视频回放推广二维码课名
    replaceVideoCodePromoteCourseNumber() {
      if (
        this.newAnnouncementForm.videoCodePromoteCourseNumber !=
        this.tempAnnouncementForm.videoCodePromoteCourseNumber
      ) {
        this.getScheduleByCourse(
          this.newAnnouncementForm.videoCodePromoteCourseNumber,
          5
        );
        this.tempAnnouncementForm.videoCodePromoteDateAndTime = "";
        this.newAnnouncementForm.videoCodePromoteDateAndTime = "";
      }
    },
    // 替换视频回放推广二维码课名
    enterReplaceVideoCodePromoteCourseNumber() {
      this.tempAnnouncementForm.videoCodePromoteCourseNumber = this.newAnnouncementForm.videoCodePromoteCourseNumber;
      this.tempAnnouncementForm.videoCodePromoteDateAndTime = this.newAnnouncementForm.videoCodePromoteDateAndTime;
      this.videoCodePromoteDialogFormVisible = false;
    },
    // 检索课名等字符串
    searchString() {
      this.newAnnouncementForm.courseName = "";
      this.newAnnouncementForm.dateAndTime = "";
      this.newAnnouncementForm.companyName = "";
      this.newAnnouncementForm.address = "";
      this.newAnnouncementForm.studyReportDateAndTime = "";
      this.newAnnouncementForm.studyReportCourseNumber = "";
      this.newAnnouncementForm.courseCodeCourseNumber = "";
      this.newAnnouncementForm.courseEnrollCodeCourseNumber = "";
      this.newAnnouncementForm.courseEnrollCodeDateAndTime = "";
      this.newAnnouncementForm.videoCodeCourseNumber = "";
      this.newAnnouncementForm.videoCodeDateAndTime = "";
      this.newAnnouncementForm.videoCodePromoteCourseNumber = "";
      this.newAnnouncementForm.videoCodePromoteDateAndTime = "";
      this.tempAnnouncementForm = {
        courseName: "",
        courseDate: "",
        address: "",
        companyName: "",
        studyReportCourseNumber: "",
        studyReportDateAndTime: "",
        courseCodeCourseNumber: "",
        courseEnrollCodeCourseNumber: "",
        courseEnrollCodeDateAndTime: "",
        videoCodeCourseNumber: "",
        videoCodeDateAndTime: "",
        videoCodePromoteCourseNumber: "",
        videoCodePromoteDateAndTime: ""
      };
      this.getCourseNameList();
      this.getCompanyList();
      let courseNameCheck = /\【课名】/g;
      let dateAndTimeCheck = /\【日期与时间】/g;
      let companyCheck = /\【公司】/g;
      let addressCheck = /\【地点】/g;
      let studyReportLinkCheck = /\【学习报告链接】/g;
      let courseCodeCheck = /\【课程二维码】/g;
      let courseEnrollCodeCheck = /\【课程报名二维码】/g;
      let videoCodeCheck = /\【视频回放二维码】/g;
      let videoCodePromoteCheck = /\【视频回放推广二维码】/g;
      // 控制课名按钮
      if (this.templateForm.textarea.match(courseNameCheck)) {
        this.courseNameView = true;
      } else {
        this.courseNameView = false;
      }
      // 日期与时间按钮
      if (this.templateForm.textarea.match(dateAndTimeCheck)) {
        this.dateAndTimeView = true;
      } else {
        this.dateAndTimeView = false;
      }
      // 公司按钮
      if (this.templateForm.textarea.match(companyCheck)) {
        this.companyView = true;
      } else {
        this.companyView = false;
      }
      // 地点按钮
      if (this.templateForm.textarea.match(addressCheck)) {
        this.addressView = true;
      } else {
        this.addressView = false;
      }
      // 学习报告链接按钮
      if (this.templateForm.textarea.match(studyReportLinkCheck)) {
        this.studyReportLinkView = true;
      } else {
        this.studyReportLinkView = false;
      }
      // 课程二维码按钮
      if (this.templateForm.textarea.match(courseCodeCheck)) {
        this.courseCodeView = true;
      } else {
        this.courseCodeView = false;
      }
      // 课程报名二维码按钮
      if (this.templateForm.textarea.match(courseEnrollCodeCheck)) {
        this.courseEnrollCodeView = true;
      } else {
        this.courseEnrollCodeView = false;
      }
      // 视频回放二维码按钮
      if (this.templateForm.textarea.match(videoCodeCheck)) {
        this.videoCodeView = true;
      } else {
        this.videoCodeView = false;
      }
      // 视频回放推广二维码按钮
      if (this.templateForm.textarea.match(videoCodePromoteCheck)) {
        this.videoCodePromoteView = true;
      } else {
        this.videoCodePromoteView = false;
      }
      // 主页面显示模板
      this.newAnnouncementForm.desc = this.templateForm.textarea;
      this.templateFormVisible = false;
    },
    // 选择的标签
    handleClick(tab, event) {
      console.log(tab, event);
    },
    getLimitCouponCode() {
      this.showFlag = true;
    },
    editDiscount(row) {
      console.log(row);
      this.newAnnouncementForm = row;
      this.courseNameDialogFormVisible = true;
    },
    reset() {
      this.newAnnouncementForm = {};
      this.showFlag = false;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    }
  },
  mounted() {
    if (this.$route.query.emailGroupId) {
      if (Number(this.$route.query.emailGroupId) === 0) {
        this.emailGroupId = Number(this.$route.query.emailGroupId);
        // console.log(
        //   "🚀 ~ file: P0405.vue:1419 ~ mounted ~ this.emailGroupId :",
        //   this.emailGroupId
        // );
        this.noticeAllFlag = true;
      } else {
        this.emailGroupId = Number(this.$route.query.emailGroupId);
        // console.log(
        //   "🚀 ~ file: P0405.vue:1423 ~ mounted ~ this.emailGroupId:",
        //   this.emailGroupId
        // );
        this.noticeAllFlag = false;
      }
    }
    this.getCompanyList();
    this.getCourseNameList();
    if (this.$route.query.groupName) {
      this.groupName = this.$route.query.groupName;
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  width: 80%;
  margin: 0 auto;
  padding-top: 17px;
  // display: flex;
}

>>> .el-form-item {
  margin-bottom: 0%;
  text-align: left;
}
.couponType >>> .el-form-item__content {
  line-height: 30px;
}
.foot-container {
  margin: 40px auto 0 auto;
  height: 26px;
  text-align: center;
}
.noticeInputCenter >>> .el-input__inner {
  text-align: center;
  // font-size: 18px;
}
// 遮罩颜色
>>> .el-dialog__wrapper {
  background: rgba(88, 88, 88, 0.4);
}
>>> .el-dialog__body {
  color: #000000;
  font-family: sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/views/Marketing/EmailMarketing/P0405.vue